import React from 'react';
import Zoom from 'react-reveal/Zoom';
import Bounce from 'react-reveal/Bounce';
import styled from 'styled-components';
import { StyledAboutIntroTitle, StyledAboutIntroTitleWrapper, StyledAboutIntroWrapper } from './AboutIntro.style';
import ShutterText from '../../IndexPage/ShutterText';
import { useMobile } from '../../queries';

const ColoredTitle = styled.span`
color: ${(props) => props.color};
    font-family: 'Anton', sans-serif !important;
    letter-spacing: 2px;
`;


function AboutIntro() {
  const isMobile = useMobile();
  return (
    <StyledAboutIntroWrapper>
      <StyledAboutIntroTitleWrapper>
        <StyledAboutIntroTitle>
          <Zoom right cascade>
                You have
          </Zoom>
          <ColoredTitle color="#34c7de">
            {' '}
            <Zoom delay={1000}>five seconds  </Zoom>
            {isMobile && <br />}
          </ColoredTitle>
          <Zoom right cascade delay={1000}>
            {' '}
                to
            {' '}
          </Zoom>
          <Bounce top delay={1500}>
            <ColoredTitle color="#de6b34">
                    impact
              {' '}
            </ColoredTitle>
          </Bounce>
          <Zoom right cascade delay={2000}>
            {' '}
                your audience
            <br />
          </Zoom>
          <Zoom right cascade delay={2700}>
                We are here to
            {' '}
          </Zoom>
          <ColoredTitle color="#ffaaaa">
            <Bounce right delay={3600}>do it for you </Bounce>
            {' '}
          </ColoredTitle>
          <br />
          <Zoom right cascade delay={4200}>We are The </Zoom>
          <br />
          <ShutterText text="SHAPIRA BROTHERS" />
        </StyledAboutIntroTitle>
      </StyledAboutIntroTitleWrapper>
    </StyledAboutIntroWrapper>
  );
}

export default AboutIntro;
